/**
 * Massimo Landing — sticky nav, smooth scroll, hero video.
 * Vanilla JS · ES5+ uyumlu · prefix: massimo-
 * v1.0.0 — 2026-05-16
 *
 * NOT: Stage chrome (üst Direction switcher) production'da yok.
 *      Direction (editorial/arch/cinema), Shopify section setting'inden
 *      .massimo-root[class*="dir-"] olarak Liquid'de set ediliyor.
 */
(function() {
  'use strict';

  // ─── 1. Sticky nav class toggle (scroll > 80px → .is-scrolled) ───
  function initStickyNav() {
    var nav = document.querySelector('.massimo-nav');
    if (!nav) return;

    var threshold = 80;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop;
      if (y > threshold) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    function requestUpdate() {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    onScroll(); // ilk durum
  }

  // ─── 2. Smooth scroll for in-page anchors (#story, #kalite vb.) ───
  function initSmoothScroll() {
    document.addEventListener('click', function(e) {
      var t = e.target;
      // closest polyfill için manuel walk
      var a = null;
      while (t && t !== document) {
        if (t.tagName === 'A' && t.getAttribute('href') &&
            t.getAttribute('href').charAt(0) === '#') {
          a = t;
          break;
        }
        t = t.parentNode;
      }
      if (!a) return;

      var href = a.getAttribute('href');
      if (href === '#' || href.length < 2) return;

      var id = href.slice(1);
      // URL-decode (Türkçe karakter desteği için: #özel → özel)
      try { id = decodeURIComponent(id); } catch (err) {}

      var target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      if (target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // Eski tarayıcı fallback
        window.scrollTo(0, target.offsetTop);
      }

      // URL hash güncelle (history kirletmeden)
      if (history && history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    });
  }

  // ─── 3. Hero video — iOS/Android autoplay garantisi ───
  function initHeroVideo() {
    var video = document.querySelector('.massimo-hero-media');
    if (!video) return;

    // iOS autoplay şartları
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.playsInline = true;

    function attemptPlay() {
      var p = video.play();
      if (p && typeof p['catch'] === 'function') {
        p['catch'](function() {
          // Autoplay engellendi — poster görseli zaten görünüyor, sessizce devam
        });
      }
    }

    if (video.readyState >= 2) {
      attemptPlay();
    } else {
      video.addEventListener('loadeddata', attemptPlay, { once: true });
      video.addEventListener('canplay', attemptPlay, { once: true });
    }

    // Sayfa görünür olunca tekrar dene (sekme dönüşü vs.)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden && video.paused) attemptPlay();
    });
  }

  // ─── 4. Init ───
  function init() {
    initStickyNav();
    initSmoothScroll();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API (gerekirse Liquid'den manuel tetikleme için)
  window.__massimoLanding = {
    initStickyNav: initStickyNav,
    initSmoothScroll: initSmoothScroll,
    initHeroVideo: initHeroVideo,
    version: '1.0.0'
  };

  console.log('[Massimo Landing] v1.0.0 yüklendi');
})();
